(function () {
  'use strict';
  if (window.__vtProductCard) return;
  window.__vtProductCard = true;

  function data(card) {
    if (card.__vt) return card.__vt;
    var el = card.querySelector('[data-pc-json]');
    try { card.__vt = JSON.parse(el.textContent); } catch (e) { card.__vt = { v: [] }; }
    return card.__vt;
  }
  function sized(url, w) { return url.replace(/([?&])width=\d+/, '$1width=' + w); }
  function findVariant(d, size) {
    return d.v.filter(function (v) {
      var okC = d.cp === null || v.o[d.cp] === d.color;
      var okS = size == null || d.sp === null || v.o[d.sp] === size;
      return okC && okS;
    })[0];
  }
  function syncSizes(card) {
    var d = data(card);
    card.querySelectorAll('[data-size]').forEach(function (b) {
      var v = findVariant(d, b.dataset.size);
      b.disabled = !v || !v.a;
      b.setAttribute('aria-label', 'Talla ' + b.dataset.size + (b.disabled ? ', agotada' : ', agregar a la bolsa'));
    });
  }
  function setColor(card, color) {
    var d = data(card);
    d.color = color;
    card.querySelectorAll('[data-color]').forEach(function (b) {
      var on = b.dataset.color === color;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var v = d.v.filter(function (x) { return d.cp !== null && x.o[d.cp] === color && x.img; })[0];
    var img = card.querySelector('[data-pc-main]');
    if (v && img) {
      img.srcset = [360, 540, 720, 1000].map(function (w) { return sized(v.img, w) + ' ' + w + 'w'; }).join(', ');
      img.src = sized(v.img, 720);
    }
    syncSizes(card);
  }

  var toast = null, toastT = null;
  function notify(msg, ok) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'vt-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    toast.innerHTML = '<span></span>' + (ok ? '<a href="' + cartUrl + '">Ver bolsa</a>' : '');
    toast.firstChild.textContent = msg;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 3800);
  }

  function add(card, btn, variant) {
    if (!variant || !variant.a) return;
    btn.classList.add('is-busy');
    var label = btn.textContent;
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        if (btn.hasAttribute('data-add')) btn.textContent = 'Agregado';
        setTimeout(function () { btn.classList.remove('is-done'); if (btn.hasAttribute('data-add')) btn.textContent = label; }, 1800);
        try {
          var qa = JSON.parse(localStorage.getItem('vt_qa') || '[]').filter(function (x) { return x !== String(variant.id); });
          qa.unshift(String(variant.id));
          localStorage.setItem('vt_qa', JSON.stringify(qa.slice(0, 80)));
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('vt:cart:updated', { detail: { itemCount: cart.item_count, cart: cart } }));
        if (document.querySelector('[data-vt-cart-drawer], [data-vt-cart-page]')) {
          document.dispatchEvent(new CustomEvent('vt:cart:open', { detail: { trigger: btn, variantId: variant.id } }));
        } else {
          var name = card.querySelector('.vt-pc__name');
          notify((name ? name.textContent.trim() : 'Prenda') + ' quedó en tu bolsa', true);
        }
        card.classList.remove('is-qa');
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        notify((err && (err.description || err.message)) || 'No pudimos agregarla. Intenta de nuevo.', false);
      });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-vt-pc]');
    if (!card) return;
    var sw = e.target.closest('[data-color]');
    if (sw) { e.preventDefault(); setColor(card, sw.dataset.color); return; }
    var tg = e.target.closest('[data-pc-toggle]');
    if (tg) {
      e.preventDefault();
      var on = !card.classList.contains('is-qa');
      document.querySelectorAll('[data-vt-pc].is-qa').forEach(function (c) { if (c !== card) { c.classList.remove('is-qa'); var t = c.querySelector('[data-pc-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); } });
      card.classList.toggle('is-qa', on);
      tg.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) syncSizes(card);
      return;
    }
    var sz = e.target.closest('[data-size]');
    if (sz) { e.preventDefault(); add(card, sz, findVariant(data(card), sz.dataset.size)); return; }
    var ad = e.target.closest('[data-add]');
    if (ad) { e.preventDefault(); add(card, ad, findVariant(data(card), null)); }
  });
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('[data-vt-pc]');
    if (card && !card.__vtSynced) { card.__vtSynced = true; syncSizes(card); }
  });
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest('[data-vt-pc]');
    if (card && !card.__vtSynced) { card.__vtSynced = true; syncSizes(card); }
  });
})();
